import { AutoComplete, Input } from 'antd';
import React, { ReactElement, useEffect, useState } from 'react';
import { FETCH_ALL_STATE } from '../../../shared/constants/commonConstants';
import { AllStateResponse, StateOption } from '../../../shared/models/hospitalProfile.model';
import SendRequest from '../../../shared/services/sendRequest.service';

const AllStateAutoComplete = ({ onStateSelect, dValue, onSelectEvent }: any): ReactElement => {
  const [states, setStates] = useState([] as any[]);
  const [value, setValue] = useState(null as any);
  useEffect((): void => {
    if (states.length <= 0) {
      fetchAllStates();
    }
    if (dValue) {
      setValue(dValue);
    }
    // eslint-disable-next-line
  }, [dValue]);

  useEffect((): void => {
    onSelect(value);
  }, [value, states]);

  const fetchAllStates = async (): Promise<void> => {
    const stateResponse: AllStateResponse = await SendRequest.instance.get(process.env.REACT_APP_BASE_URL + FETCH_ALL_STATE);
    if (stateResponse && stateResponse.isSuccess && stateResponse.keywordLookupDetails && stateResponse.keywordLookupDetails.length > 0) {
      setStates(stateResponse.keywordLookupDetails.map((state: StateOption): StateOption => {
        return { id: state.id, value: state.name };
      }));
    }
  };

  const onStateFilter = (inputValue: string, option: any): boolean =>
    option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1;

  const onSelect = (e: string, isSelect?: string): void => {
    const [state] = states.filter((stateOption: StateOption): boolean => stateOption.value === e);
    if (isSelect) {
      onStateSelect(state);
      onSelectEvent();
    }
  };

  const onFocus = (event: any): void => {
    if (event.target.autocomplete) {
      event.target.autocomplete = 'autocomplete';
    }
  };

  const onChange = (e: any): void => {
    setValue(e);
    if (e === '') {
      onStateSelect(null);
      onSelectEvent();
    }
  };

  return (
    <AutoComplete value={value}
      onChange={onChange}
      filterOption={onStateFilter} options={states} placeholder="State" onSelect={(e: any): void => onSelect(e, 'select')}>
      <Input onFocus={onFocus} />
    </AutoComplete>
  );
};

export default AllStateAutoComplete;
